import SignalAlertWorkflowDetail from '@/features/Workflow/WorkflowDetail/signal-alert/SignalAlertWorkflowDetail';

const CreateSignalAlertPage = () => {
  return <SignalAlertWorkflowDetail mode="CREATE" />;
};

export default CreateSignalAlertPage;
